<template>
  <div style="background-color: #f7f1f7;">
    <div class="container">
      <div class="links">
        <ul class="links__list">
          <li>
            <el-tooltip placement="top">
              <a> <i class="icon-ios"></i> <span>玩转工厂 - 手机</span> </a>
              <div slot="content">
                <img src="@/assets/images/imgqr/qrcode_ios.png" width="140" />
              </div>
            </el-tooltip>
          </li>
          <li>
            <el-tooltip placement="top">
              <a> <i class="icon-android"></i> 玩转工厂 - 手机 </a>
              <div slot="content">
                <div>
                  <a class="btn_googlepaly"></a>
                  <a
                    class="btn_url btn_download"
                    :href="buttonDownloadUrl(0)"
                    target="_blank"
                    >download</a
                  >
                </div>
              </div>
            </el-tooltip>
          </li>
          <li>
            <a :href="buttonDownloadUrl(2)" target="_blank">
              <i class="icon-android"></i> 玩转工厂 - TV大屏
            </a>
          </li>
          <li>
            <a :href="buttonDownloadUrl(0)" target="_blank">
              <i class="icon-android"></i> 玩转工厂 - PDA
            </a>
          </li>
          <li>
            <a :href="buttonDownloadUrl(3)" target="_blank">
              <i class="icon-android"></i> 玩转工厂 - 工位平板
            </a>
          </li>
          <li>
            <a :href="buttonDownloadUrl(4)" target="_blank">
              <i class="icon-android"></i> 玩转工厂 - 会议版
            </a>
          </li>
          <li>
            <a href="https://www.foxlean.com" target="_blank">
              <i class="icon-windows"></i> 玩转工厂 - 工位平板
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    urlStringType0: String,
    urlStringType2: String,
    urlStringType3: String,
    urlStringType4: String
  },
  data() {
    return {};
  },
  methods: {
    buttonDownloadUrl(val) {
      switch (val) {
        case 0:
          return this.urlStringType0;
        case 2:
          return this.urlStringType2;
        case 3:
          return this.urlStringType3;
        case 4:
          return this.urlStringType4;
        default:
          return "";
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.div-top {
  padding-top: 40px;
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 40px;
  margin-top: 100px;
}
.btn {
  position: relative;
  width: 173px;
  height: 51px;
  margin-bottom: 40px;
  margin-left: 40px;
  margin-right: 40px;
  background-size: 100%;
  background-position: 50%;
  background-repeat: no-repeat;
}
.btn_android_wrap {
  position: absolute;
  top: -106px;
  left: 5px;
  width: 173px;
  background: #525252;
  border-radius: 10px;
}
.banner__download-item {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: hsla(0,0%,100%,.07);
  color: hsla(0,0%,100%,.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 24px;
  font-size: 14px;
  cursor: pointer;
}
.icon-android, .icon-ios, .icon-android, .icon-windows  {
    display: inline-block;
    vertical-align: middle;
    width: 80px;
    height: 80px;
    background-size: cover;
}
.btn_googlepaly {
  background-image: url("../../../assets/images/imgqr/appstroe_android.png")
    margin-bottom: 1px;
}
.btn_googlepaly, .btn_url {
    display: block;
    width: 173px;
    height: 52px;
    background-repeat: no-repeat;
    background-size: 173px;
    line-height: 900px;
    overflow: hidden;
}
.btn_download {
  background-image: url("../../../assets/images/imgqr/download_android.png")
}
.links {
  animation: a 1s both;
  padding: 72px 0;
  margin: 0 80px 0 112px;
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.links__list {
  display: flex;
  flex-wrap: wrap;
  width: 984px;
}
li, ul {
  list-style: none;
  margin: 0;
}
.links__list li {
  // width: 214px;
  // height: 180px;
  width: 260px;
  height: 200px;
  padding-right: 32px;
  padding-bottom: 32px;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
}
.links__list a {
    color: rgba(0,0,0,.9);
}
a {
    text-decoration: none;
}
.links__list li a {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: #fff;
  border-radius: 8px;
  transition: transform .3s;
  line-height: 36px;
}
.icon-transfer, .icon-ios, .icon-android, .icon-windows  {
  display: inline-block;
  vertical-align: middle;
  width: 80px;
  height: 80px;
  background-size: cover;
}
.icon-ios {
  background-image: url("../../../assets/images/icon/icon_ios.png")
}
.icon-android {
  background-image: url("../../../assets/images/icon/icon_android.png")
}
.icon-windows  {
  background-image: url("../../../assets/images/icon/icon_windows.png")
}
.banner__download-item_ios .banner__download-qrcode {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  opacity: 0;
  font-size: 14px;
  white-space: nowrap;
}
.banner__download-qrcode i {
  margin-top: 0;
  display: inline-block;
  vertical-align: middle;
  width: 86px;
  height: 86px;
  background-size: cover;
  background-image: url()
}
</style>



// WEBPACK FOOTER //
// src/pages/download/components/DownloadPage.vue